import { CUSTOMER, SIMPLR_BOT } from 'constants/sources';
import { TICKET_STATUS_ASSIGNED } from 'constants/ticketStatuses';
import { isLiveChat } from './chat';

const EXPIRATION_TIME_30_SECONDS = 3e4;
const EXPIRATION_TIME_3_MINUTES = 18e4;

export const showTicketExpiryTimer = (ticket, isAdmin) => {
  const isTicketAssigned = ticket.ticketStatus === TICKET_STATUS_ASSIGNED;
  const isChat = isLiveChat(ticket.communicationType);
  const lastMsgFromCustomerOrBot = [CUSTOMER, SIMPLR_BOT].includes(ticket.lastMessageSource);

  return isTicketAssigned && !isAdmin && isChat && lastMsgFromCustomerOrBot;
};

export const getExpiryTimeForTicket = (ticket) =>
  ticket.lastMessageSource === SIMPLR_BOT ? EXPIRATION_TIME_30_SECONDS : EXPIRATION_TIME_3_MINUTES;

export const calcExpiryTime = (lastUpdateTime, ticketExpiresIn) => {
  const lastTicketUpdate = new Date(lastUpdateTime).getTime();
  const willBeExpiredAt = lastTicketUpdate + ticketExpiresIn;
  const currentTime = new Date().getTime();

  return willBeExpiredAt - currentTime;
};
